import React, { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import styles from "./TransactionDetailsPage.module.scss";
import { IndexerService } from "../../services/indexer.service";
import { TransactionResponse } from "../../models/Response";
import { QueryKey, TransactionType } from "../../models/enums";
import { Loader } from "@mantine/core";
import TransactionDetailsTable from "../../components/transactionDetailsTable/TransactionDetailsTable.component";
import { ExportImportTransaction } from "../../models/Transaction";

export default function TransactionDetailsPage(): ReactElement | null {
  const { transactionId } = useParams();
  const {
    data: transaction,
    isLoading: transactionLoading,
    error: error,
  } = useQuery({
    queryKey: [QueryKey.transaction, transactionId],
    queryFn: async (): Promise<TransactionResponse> =>
      IndexerService.getTransaction(transactionId!),
    enabled: !!transactionId,
    staleTime: Infinity,
  });

  const { data: importExportTransaction } =
    useQuery({
      queryKey: [QueryKey.importExportTransactionByExportId, transactionId],
      queryFn: async (): Promise<ExportImportTransaction | null> => {
        const response = await IndexerService.getCChainTransactionByImportedInputId(
          transactionId!,
        );
        return response;
      },
      enabled: transaction?.data?.type === TransactionType.EXPORT_TX,
      staleTime: Infinity,
      retry: false,
    });

  if (error) {
    console.error("Error ", error);
  }

  return (
    <>
      {transactionLoading ? (
        <Loader size={50} style={{ paddingTop: "20%" }} />
      ) : (
        <div className={styles.txContainer}>
          <div className={styles.txHeader}>
            <h2 className={styles.pageTitle}>Transaction details</h2>
          </div>
          <TransactionDetailsTable transaction={transaction} exportTransactionId={importExportTransaction?.tx_id} />
        </div>
      )}
    </>
  );
}
